import styled from 'styled-components';
import { useSelector } from 'react-redux';
const CardSkeleton = () => {
  const isMobile = useSelector((state: any) => state.app.isMobile);
  return (
    <Container>
      <div className="cover-skeleton" />
      <div className="details-skeleton">
        <div className="header-skeleton">
          <span className="title-skeleton"></span>

          {!isMobile && <span className="cover-logo" />}
        </div>
        <div className="header-skeleton">
          {isMobile && <span className="cover-logo" />}
          <div className="description-skeleton" />
        </div>
        {!isMobile && <div className="badges-skeleton" />}
        <div className="payment-skeleton" />
        <div className="price-skeleton" />

        <div className="buttons-skeleton">
          <span />
          <span />
        </div>
      </div>
    </Container>
  );
};
const Container = styled.div`
  width: 100%;
  display: flex;
  padding: 8px;
  border-radius: 12px;
  border: 1px solid #d3dbe6;
  height: 230px;

  .details-skeleton {
    gap: 16px;
    padding: 0px 16px;
    width: 100%;
    align-self: center;
    opacity: 0;
    animation: fadeIn 1.5s linear forwards infinite alternate;

    @keyframes fadeIn {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }

    .header-skeleton {
      display: flex;
      gap: 4px;
      margin-bottom: 4px;
      .title-skeleton {
        background: #edf1f6;
        border-radius: 4px;
        width: 100%;
        height: 26px;
      }
      .cover-logo {
        height: 24px;
        width: 24px;
        background: #e4e9f0;
        border-radius: 50%;
        position: relative;
      }
    }
    .description-skeleton {
      width: 145px;
      height: 21px;
      background: #e4e9f0;
      border-radius: 4px;
    }
    .badges-skeleton {
      width: 123px;
      height: 17px;
      background: #e4e9f0;
      border-radius: 4px;
      margin: 16px 0px;
    }
    .payment-skeleton {
      width: 240px;
      height: 24px;
      background: #edf1f6;
      border-radius: 4px;
      margin-bottom: 8px;
    }
    .price-skeleton {
      width: 240px;
      height: 17px;
      background: #e4e9f0;
      border-radius: 4px;
      margin-bottom: 16px;
    }
    .buttons-skeleton {
      display: flex;
      justify-content: space-between;
      gap: 10px;
      span {
        width: 100%;
        height: 37px;
        border-radius: 12px;
        background: #edf1f6;
      }
    }
  }
  .cover-skeleton {
    position: relative;
    min-width: 303px;
    height: 214px;
    border-radius: 10px;
    background: #e4e9f0;
    animation: fadeIn 1s linear forwards infinite alternate;

    @keyframes fadeIn {
      from {
        opacity: 1;
      }
      to {
        opacity: 0.5;
      }
    }
  }

  @media (max-width: ${props => props.theme.breakPoints.mobile.max}) {
    flex-direction: column;
    padding: 0;
    padding-bottom: 16px;
    height: auto;

    .header-skeleton {
      margin: 10px 0px !important;
    }
    .cover-skeleton {
      width: 100%;
      height: 214px;
      border-bottom-left-radius: 0px;
      border-bottom-right-radius: 0px;
      margin-bottom: 10px;
    }
    .description-skeleton {
      width: 120px !important;
    }
  }
`;
export default CardSkeleton;
